<template>
<div class="document-view" style="position:relative;text-align:center">


    <div @click="dialogVisible = true">
        <slot>
        <img alt=" " v-if="hasImage" :src="url" style="max-width:100%;max-height:100%;" @click="dialogVisible = true"/>

        <template v-if="hasPdf">
            <object :data="url" :type="type" style="max-width:100%;max-height:100%" @click="dialogVisible = true">
                alt: <a :href="url">Open</a>
            </object>   
            <v-btn @click="dialogVisible = true" rounded dark color="grey lighten-1 mb-3" :width="150" class="">Open</v-btn>
        </template>
        </slot>
    </div>

    <!-- <v-dialog v-model="dialogVisible" :max-width="800"> -->
    <div class="simple-dialog" v-if="dialogVisible" @click="dialogVisible = false">

        <div class="centered" @click.stop>
            <div v-if="hasImage" style="max-height:100%;overflow-y:auto;">
                <img alt=" " :src="url" style="vertical-align:top;max-width:100%;max-height:100%;"/>
            </div>
            <object v-if="hasPdf" :data="url" type="application/pdf" style="max-width:100%;max-height:100%%;width:800px;height:800px">
                alt: <a :href="url">Open</a>
            </object>              
        </div>


        <!-- Buttons 
        -->
        <!-- <div class="preview-buttons" :activeClass="null" :class="{'show-lower': hasPdf}">

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                    <a :href="url" class="transparent" target="_blank">
                        <v-btn dark>
                            <v-icon>open_in_new</v-icon>
                        </v-btn>
                    </a>
                </div>
              </template>
              <span>Open in New Tab</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                    <v-btn dark @click="dialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>                   
                </div>
              </template>
              <span>Close Preview</span>
            </v-tooltip>


        </div> -->

        <div class="hover-bar">
            <div>
                <div style="border-right: solid 1px #555;">
                <a :href="url" class="transparent" target="_blank">
                    New Tab
                </a>
                </div>
                <!-- <div class="middle">
                    Download
                </div> -->
                <div @click="dialogVisible = false">
                    Close
                </div>
            </div>
        </div>
 
  

    <!-- </v-dialog> -->
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
            dialogVisible: false,
            zoom: false,
        }
    },

    components: {
        
    },
    
    props: {
        url: String,
        type: {
            type: String,
            default: '',
        } 
    },

    computed: {
        hasImage() {
            return this.type.contains('image') 
                || this.url.contains('.jpg')
                || this.url.contains('.png')
                || this.url.contains('.gif')

        },
        hasPdf() {
            return (this.type.contains('pdf')
                || this.url.contains('.pdf')) && !this.hasImage

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>
.document-view {
    position:relative;
}

.hover-bar {
    position:absolute;
    bottom:30px;
    left:0;
    right:0;
    height:30px;
}

.hover-bar > div {
    background-color: rgba(0,0,0,0.7);
    border-radius: 100px;
    color: rgba(255,255,255,0.8);
    display: inline-block;
    padding: 0 5px;

}
.hover-bar > div > div {
    display:inline-block;
    padding:10px;
}
.hover-bar > div > div:hover {
    color: white;
}

.hover-bar .middle {
    border-right: solid 1px #555;
    border-left: solid 1px #555;

}

/*
.document-view-window {
    width:200px;
   
}

.document-view.zoom {
    z-index:99;
    width:auto;
    position:fixed;
    left:10%;right:10%;top:10%;bottom:10%;
    max-width:1000px;
    border: solid 5px orange;
    background-color:white;
    
}
.document-view-window.zoom {
    width:500px;
    height:500px;
} */

.preview-buttons {
    position:absolute;right:15px;top:10px;
    opacity: 0.8;
    display:flex;
    gap:10px;
}

.preview-buttons.show-lower {
    position:absolute;right:15px;top:70px
}

.simple-dialog {
    position:fixed;
    top:0px;
    left: 0px;
    bottom: 0px;
    right:0px;
    background-color:rgba(0,0,0,0.7);
    z-index:100;
}

.centered {
  color: white;
  background: black;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
  max-height:95%;
  max-width: 95%;
} 

</style>




// WEBPACK FOOTER //
// DocumentView.vue?ed432090